import React from "react";
import { makeStyles } from '@mui/styles';
import Container from '@mui/material/Container';

const HomeContainer = ({ children, ...rest }) => {
  const classes = useStyles();
  return (
    <Container className={classes.container} {...rest}>
      {children}
    </Container>
  );
};

const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: '50px',
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    paddingTop: `calc( ${theme.spacing(4)}px + ${theme.navbarHeight} ) `,
    paddingBottom: theme.spacing(4),
    [theme.breakpoints.down('sm')]: {
      paddingTop: theme.navbarHeight,
    },
  },
}));

export default HomeContainer;
